import {BenchlingAction} from 'redux-stores/Action';

import {PresenceActionType} from './PresenceReduxActions';

export interface PresenceState {
  [resourceId: string]: PresenceResourceState;
}

export interface PresenceResourceState {
  presentClients: Array<PresenceClientConnection>;
}

interface PresenceClientConnection {
  userId: string;
  ablyConnectionId: string;
}

const INITIAL_STATE: PresenceState = {};

export default function reducePresence(
  state: PresenceState = INITIAL_STATE,
  action: BenchlingAction
): PresenceState {
  switch (action.type) {
    case PresenceActionType.PRESENCE_ENTER:
      return {
        ...state,
        [action.resourceId]: {
          presentClients: [
            // Remove any existing connections with the same connectionID
            ...filterByAblyConnectionIds(state[action.resourceId]?.presentClients, [action.ablyConnectionId]),
            {userId: action.userId, ablyConnectionId: action.ablyConnectionId},
          ],
        },
      };
    case PresenceActionType.PRESENCE_LEAVE:
      return {
        ...state,
        [action.resourceId]: {
          presentClients: filterByAblyConnectionIds(state[action.resourceId]?.presentClients, [
            action.ablyConnectionId,
          ]),
        },
      };
    case PresenceActionType.PRESENCE_CLEANUP:
      return {
        ...state,
        [action.resourceId]: {
          presentClients: [],
        },
      };
    case PresenceActionType.PRESENCE_MULTI_ENTER:
      return {
        ...state,
        [action.resourceId]: {
          presentClients: [
            ...filterByAblyConnectionIds(
              state[action.resourceId]?.presentClients,
              action.members.map((member) => member.ablyConnectionId)
            ),
            ...action.members,
          ],
        },
      };
    default:
      return state;
  }
}

function filterByAblyConnectionIds(
  presentClients: Array<PresenceClientConnection> | undefined,
  ablyConnectionIds: Array<string>
): Array<PresenceClientConnection> {
  return (presentClients ?? []).filter(
    (clientConnection) => !ablyConnectionIds.includes(clientConnection.ablyConnectionId)
  );
}
